import React from 'react'
import { GrowthMetricHeatmapChart } from './GrowthMetricHeatmapShared'
import { resolveGeographySubtitleLabel } from './NetFlowsHeatmapShared'

const REVENUE_HEATMAP_COLORS = {
  belowZero: { color: '#E5546C', fontColor: '#ffffff' },
  zeroToThree: { color: '#99e6ff', fontColor: '#000000' },
  threeToSix: { color: '#75f0e7', fontColor: '#000000' },
  sixToNine: { color: '#00a9f4', fontColor: '#000000' },
  nineToTwelve: { color: '#2251ff', fontColor: '#ffffff' },
  aboveTwelve: { color: '#061f79', fontColor: '#ffffff' },
  na: { color: 'rgb(230, 230, 230)', fontColor: '#000000' },
}

function formatRevenueWithOneDecimal(num) {
  if (num == null || Number.isNaN(Number(num))) return 'n/a'
  return Number(num).toLocaleString('en-US', {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  })
}

const REVENUE_HEATMAP_CONFIG = {
  colorMap: REVENUE_HEATMAP_COLORS,
  bucketRules: [
    { min: 0, max: 3, key: 'zeroToThree' },
    { min: 3, max: 6, key: 'threeToSix' },
    { min: 6, max: 9, key: 'sixToNine' },
    { min: 9, max: 12, key: 'nineToTwelve' },
    { min: 12, max: Infinity, key: 'aboveTwelve' },
  ],
  formatDisplayValue: formatRevenueWithOneDecimal,
  getHeaderTitle: (endYear) => `Net Revenues at YE ${endYear}`,
  getLegendTitleSingle: (firstYear) => `Net Revenues CAGR, ${firstYear}`,
  getLegendTitleMulti: (yearsLabel) => `Net Revenues CAGR, ${yearsLabel}`,
  getTotalColumnLabel: (endYear) => `Total Net Revenues (${endYear})`,
  growthAxisTitle: 'Net Revenues growth %',
  seriesName: 'Net Revenues growth %',
  dataClasses: [
    { from: 12, color: REVENUE_HEATMAP_COLORS.aboveTwelve.color, name: '>12%' },
    { from: 9, to: 12, color: REVENUE_HEATMAP_COLORS.nineToTwelve.color, name: '9–12%' },
    { from: 6, to: 9, color: REVENUE_HEATMAP_COLORS.sixToNine.color, name: '6–9%' },
    { from: 3, to: 6, color: REVENUE_HEATMAP_COLORS.threeToSix.color, name: '3–6%' },
    { from: 0, to: 3, color: REVENUE_HEATMAP_COLORS.zeroToThree.color, name: '0–3%' },
    { from: -100, to: -0.0001, color: REVENUE_HEATMAP_COLORS.belowZero.color, name: '<0%' },
    { from: -0.0001, to: 0, color: REVENUE_HEATMAP_COLORS.na.color, name: 'n/a' },
  ],
  buildMainCellHoverText: ({ displayValue, growthText, rowAxisLabel, yName, xName, yearsLabel }) =>
    `<b>Net Revenues: ${displayValue}</b><br />${growthText}<br />${rowAxisLabel}: ${yName}<br />Asset class: ${xName}${yearsLabel ? `<br />Years: ${yearsLabel}` : ''}`,
  buildColumnTotalHoverText: ({ displayValue, rowAxisLabel, rowName }) =>
    `Net Revenues total: <b>${displayValue}</b><br />${rowAxisLabel}: ${rowName}`,
  buildRowTotalHoverText: ({ displayValue, columnName }) =>
    `Net Revenues total: <b>${displayValue}</b><br />Asset class: ${columnName}`,
  buildGrandTotalHoverText: ({ displayValue, endYear }) =>
    `Net Revenues Grand Total (${endYear}): <b>${displayValue}</b>`,
}

export const RevenueHeatmapChart = (props) => (
  <GrowthMetricHeatmapChart {...props} config={REVENUE_HEATMAP_CONFIG} />
)

const RevenueHeatmap = (props) => (
  <RevenueHeatmapChart
    {...props}
    rowAxisLabel="Client segment"
    resolveFilterSubtitleLabel={resolveGeographySubtitleLabel}
    accessibilityPointDescription="{series.xAxis.categories.(x)} net revenues {series.yAxis.categories.(y)}, {value}."
  />
)

export default RevenueHeatmap
